"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInterstitialService = void 0;
const hooks_1 = require("../../hooks");
const useInterstitialService = (repository) => {
    const { call: getInterstitialCall, data: interstitialData, isError: isInterstitialError, isLoading: isInterstitialLoading, isSuccess: isInterstitialSuccess, reset: resetInterstitial, } = (0, hooks_1.useAsyncStateInfo)(repository.getInterstitial);
    return {
        interstitialData,
        getInterstitialCall,
        resetInterstitial,
        isInterstitialError,
        isInterstitialLoading,
        isInterstitialSuccess,
        isDataEmpty: !interstitialData?.data?.type,
    };
};
exports.useInterstitialService = useInterstitialService;
//# sourceMappingURL=useInterstitialService.hook.js.map